import { IApplicationState } from '../../types/redux';

/**
 * Выбирает все группы рекомендованных объявлений
 */
export const selectPostContentRecommendedOfferGroups = ({ postContentRecommendedOffers }: IApplicationState) =>
  postContentRecommendedOffers.items;
